import React from 'react';
import { Input } from './SearchBar.Styles';
import { 
  useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
  } from '../../../styles/theme'

interface SearchBarProps {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
  }

  export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => { 

    const isDesktopOrLaptop = useIsDesktopOrLaptop();
    const isMiniNotebook = useIsMiniNotebook();
    const isMobileBig = useIsMobileBig();
    const isMobileMedium = useIsMobileMedium();
    const isMobileMini = useIsMobileMini();
  
    return (
      <Input
      value={value}
      onChange={onChange}
      isDesktopOrLaptop={isDesktopOrLaptop}
      isMiniNotebook={isMiniNotebook}
      isMobileBig={isMobileBig}
      isMobileMedium={isMobileMedium}
      isMobileMini={isMobileMini}
    />
  )};